import img1 from '../../assets/gallery-1.png'
import img2 from '../../assets/gallery-2.png'
import img3 from '../../assets/gallery-3.png'
import img4 from '../../assets/gallery-4.png'

export let NFT__DATA  = [
    {   
        id: 1,
        title: "Shoes",
        imgUrl: img1,
        creator:"0xAdaUa1B45F4728843F8F6d3A263f10953Casfg7",
        currentBid: 0.00001,
        startDate: "03/05/2024",
        endDate: "10/05/2024",
        description: " Experience the perfect blend of style and comfort with AirMax Pro Sneakers. These shoes feature a lightweight, breathable mesh upper and a cushioned sole that provides exceptional support for all-day wear. Designed for both performance and fashion, they are ideal for running, gym sessions, or casual outings. With a sleek design and durable construction, AirMax Pro Sneakers are the perfect addition to any wardrobe.",
    },
    {   
        id: 2,
        title: "Handphone",
        imgUrl: img2,
        creator:"0x58Uai95B45F4728843F8F6d3A263f10953C11sAf57",
        currentBid: 0.000002,
        startDate: "03/05/2024",
        endDate: "10/05/2024",
        description: "Discover cutting-edge technology with the Galaxy X20 Smartphone. Boasting a stunning 6.5-inch AMOLED display, powerful octa-core processor, and 48MP triple-camera system, it delivers vibrant visuals and seamless performance. With 128GB of storage and a long-lasting 4500mAh battery, the Galaxy X20 keeps you connected and productive throughout the day. Sleek, stylish, and packed with features, it's the perfect device for both work and play.",
    },
    {   
        id: 3,
        title: "Laptop",
        imgUrl: img3,
        creator:"0x57c95B45F4728843F8F6d3A263f10953C136deEd",
        currentBid: 0.000003,
        startDate: "03/05/2024",
        endDate: "10/05/2024",
        description: "Elevate your productivity with the UltraBook Pro 15. This sleek and lightweight laptop features a 15.6-inch Full HD display, a powerful Intel i7 processor, and 16GB of RAM, ensuring smooth multitasking and performance. With a fast 512GB SSD and an impressive 12-hour battery life, it’s perfect for both work and entertainment on the go. Its premium design and durable build make it an ideal choice for professionals and students alike.",
    },
    {   
        id: 3,
        title: "Tab",
        imgUrl: img4,
        creator:"0x512C95B45F4728843F8F6d3A263f109536aIuaj",
        currentBid: 0.000004,
        startDate: "03/05/2024",
        endDate: "10/05/2024",
        description: "The TabUltra X combines versatility with performance in a sleek, portable design. Featuring a vibrant 10.2-inch Retina display, a fast octa-core processor, and 8GB of RAM, it delivers smooth multitasking and vivid visuals. With 256GB of storage and a long-lasting battery, it’s perfect for work, study, or entertainment. The included stylus and intuitive interface make it an excellent choice for both creative and productivity tasks.",
    },
];